import React from "react";
import DOMPurify from 'dompurify';
import { removeInlineStyles } from '../services/htmlUtils';
import { Container } from "react-bootstrap";

interface Section {
  sectionId: string;
  title: string;
  text: string;
  sections?: Section[];
}

interface SectionsProps {
  sections: Section[];
  level?: number; // Per gestire il livello di annidamento
}

const MainSections: React.FC<SectionsProps> = ({ sections }) => {

  if (!sections || sections.length === 0) {
    return null; 
  }
  
  return (
    <section className="bg-secondary py-4">
      <Sections sections={sections} />
    </section>
  )
}

const Sections: React.FC<SectionsProps> = ({ sections, level = 2 }) => {
  const HeadingTag = `h${Math.min(level, 6)}` as keyof JSX.IntrinsicElements;

  return (
    <>
      {sections.map((section, index) => (
        <>
          {level === 2 ? (
            <Container
              className={`py-4 ${index === sections.length - 1 ? "" : "sc-border-bottom"}`}
              key={section.sectionId}
              id={section.sectionId}
            >
              <HeadingTag className="text-tertiary">{section.title}</HeadingTag>
              <div dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(removeInlineStyles(section.text)) }} />
              {section.sections && (
              <Sections sections={section.sections} level={level + 1} />
              )}
            </Container>
          ) : (
            <div className="pt-4" key={section.sectionId}>
              <HeadingTag className="text-tertiary">{section.title}</HeadingTag>
              <div dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(removeInlineStyles(section.text)) }} />
              {section.sections && (
                <Sections sections={section.sections} level={level + 1} />
              )}
            </div>
          )}
        </>
      ))}
    </>
  );
};

export default MainSections;